export default __webpack_public_path__ + "static/media/outline-weight.c7379b68.svg";